import { IsOptional, IsString, MaxLength, MinLength } from 'class-validator';

export class CompleteInviteSetupDto {
  @IsString()
  @MinLength(8)
  newPassword!: string;

  @IsString()
  @MinLength(1)
  @MaxLength(100)
  firstName!: string;

  @IsString()
  @MinLength(1)
  @MaxLength(100)
  lastName!: string;

  @IsOptional()
  @IsString()
  locale?: string;
}
